import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ModerationDashboard, ApprovedPartnerDashboard } from './components';

const PartnerDashboard: React.FC = () => {
  const { user } = useAuth();

  // Check user status
  const isWaitingForModeration =
    user?.status === 'wait_moderation' || user?.status === 'wait_additional_data_for_moderation';

  if (isWaitingForModeration) {
    return <ModerationDashboard />;
  }

  // Default dashboard for approved partners
  return <ApprovedPartnerDashboard />;
};

export default PartnerDashboard;
